var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _rect2, _rect3, _g, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcFlagsEurUsd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 15,
    rx: 1,
    fill: "#003399"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99993 2.40002L10.1652 2.89658H10.6999L10.2673 3.20347L10.4326 3.70002L9.99993 3.39314L9.5673 3.70002L9.73255 3.20347L9.29993 2.89658H9.83468L9.99993 2.40002Z",
    fill: "#FFCB00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.15996 4.61005L6.32521 5.1066H6.85996L6.42734 5.41349L6.59258 5.91005L6.15996 5.60316L5.72734 5.91005L5.89258 5.41349L5.45996 5.1066H5.99471L6.15996 4.61005Z",
    fill: "#FFCB00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.77996 2.98004L7.9452 3.4766H8.47996L8.04733 3.78349L8.21258 4.28004L7.77996 3.97315L7.34733 4.28004L7.51258 3.78349L7.07996 3.4766H7.61471L7.77996 2.98004Z",
    fill: "#FFCB00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8499 4.59003L14.0151 5.08658H14.5499L14.1173 5.39347L14.2825 5.89003L13.8499 5.58314L13.4173 5.89003L13.5825 5.39347L13.1499 5.08658H13.6847L13.8499 4.59003Z",
    fill: "#FFCB00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.22 2.99005L12.3853 3.48661H12.92L12.4874 3.7935L12.6526 4.29005L12.22 3.98316L11.7874 4.29005L11.9526 3.7935L11.52 3.48661H12.0548L12.22 2.99005Z",
    fill: "#FFCB00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.46 6.83008L14.6253 7.32663H15.16L14.7274 7.63352L14.8926 8.13008L14.46 7.82319L14.0274 8.13008L14.1926 7.63352L13.76 7.32663H14.2948L14.46 6.83008Z",
    fill: "#FFCB00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99993 11.28L10.1652 11.7766H10.6999L10.2673 12.0835L10.4326 12.58L9.99993 12.2731L9.5673 12.58L9.73255 12.0835L9.29993 11.7766H9.83468L9.99993 11.28Z",
    fill: "#FFCB00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.76995 10.6901L7.93519 11.1866H8.46995L8.03732 11.4935L8.20257 11.9901L7.76995 11.6832L7.33732 11.9901L7.50257 11.4935L7.06995 11.1866H7.6047L7.76995 10.6901Z",
    fill: "#FFCB00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.14995 9.05005L6.3152 9.5466H6.84995L6.41733 9.85349L6.58257 10.35L6.14995 10.0432L5.71733 10.35L5.88257 9.85349L5.44995 9.5466H5.9847L6.14995 9.05005Z",
    fill: "#FFCB00"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.54998 6.83008L5.71522 7.32663H6.24998L5.81735 7.63352L5.9826 8.13008L5.54998 7.82319L5.11735 8.13008L5.2826 7.63352L4.84998 7.32663H5.38473L5.54998 6.83008Z",
    fill: "#FFCB00"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8499 9.05005L14.0151 9.5466H14.5499L14.1173 9.85349L14.2825 10.35L13.8499 10.0432L13.4173 10.35L13.5825 9.85349L13.1499 9.5466H13.6847L13.8499 9.05005Z",
    fill: "#FFCB00"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.22 10.6801L12.3853 11.1766H12.92L12.4874 11.4835L12.6526 11.9801L12.22 11.6732L11.7874 11.9801L11.9526 11.4835L11.52 11.1766H12.0548L12.22 10.6801Z",
    fill: "#FFCB00"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4444_49389)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 9,
    width: 20,
    height: 15,
    rx: 1,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4444_49389",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 9,
    width: 20,
    height: 15
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 9,
    width: 20,
    height: 15,
    rx: 1,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4444_49389)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 9,
    width: 20,
    height: 1.17,
    fill: "#B22234"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 22.82,
    width: 20,
    height: 1.17,
    fill: "#B22234"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 11.32,
    width: 20,
    height: 1.153,
    fill: "#B22234"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 13.62,
    width: 20,
    height: 1.153,
    fill: "#B22234"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 15.92,
    width: 20,
    height: 1.153,
    fill: "#B22234"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 18.22,
    width: 20,
    height: 1.153,
    fill: "#B22234"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 20.52,
    width: 20,
    height: 1.153,
    fill: "#B22234"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M4 10C4 9.44771 4.44772 9 5 9H14V17.07H4V10Z",
    fill: "#3C3B6E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.5L12.1123 12.8455H12.4755L12.1816 13.059L12.2939 13.4045L12 13.191L11.7061 13.4045L11.8184 13.059L11.5245 12.8455H11.8877L12 12.5Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.5L12.1123 15.8455H12.4755L12.1816 16.059L12.2939 16.4045L12 16.191L11.7061 16.4045L11.8184 16.059L11.5245 15.8455H11.8877L12 15.5Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M13 14L13.1123 14.3455H13.4755L13.1816 14.559L13.2939 14.9045L13 14.691L12.7061 14.9045L12.8184 14.559L12.5245 14.3455H12.8877L13 14Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.5L10.1123 12.8455H10.4755L10.1816 13.059L10.2939 13.4045L10 13.191L9.70611 13.4045L9.81836 13.059L9.52447 12.8455H9.88774L10 12.5Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M10 15.5L10.1123 15.8455H10.4755L10.1816 16.059L10.2939 16.4045L10 16.191L9.70611 16.4045L9.81836 16.059L9.52447 15.8455H9.88774L10 15.5Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M11 14L11.1123 14.3455H11.4755L11.1816 14.559L11.2939 14.9045L11 14.691L10.7061 14.9045L10.8184 14.559L10.5245 14.3455H10.8877L11 14Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12.5L8.11226 12.8455H8.47553L8.18164 13.059L8.29389 13.4045L8 13.191L7.70611 13.4045L7.81836 13.059L7.52447 12.8455H7.88774L8 12.5Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M8 15.5L8.11226 15.8455H8.47553L8.18164 16.059L8.29389 16.4045L8 16.191L7.70611 16.4045L7.81836 16.059L7.52447 15.8455H7.88774L8 15.5Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M9 14L9.11226 14.3455H9.47553L9.18164 14.559L9.29389 14.9045L9 14.691L8.70611 14.9045L8.81836 14.559L8.52447 14.3455H8.88774L9 14Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12.5L6.11226 12.8455H6.47553L6.18164 13.059L6.29389 13.4045L6 13.191L5.70611 13.4045L5.81836 13.059L5.52447 12.8455H5.88774L6 12.5Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M6 15.5L6.11226 15.8455H6.47553L6.18164 16.059L6.29389 16.4045L6 16.191L5.70611 16.4045L5.81836 16.059L5.52447 15.8455H5.88774L6 15.5Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M7 14L7.11226 14.3455H7.47553L7.18164 14.559L7.29389 14.9045L7 14.691L6.70611 14.9045L6.81836 14.559L6.52447 14.3455H6.88774L7 14Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M5 14L5.11226 14.3455H5.47553L5.18164 14.559L5.29389 14.9045L5 14.691L4.70611 14.9045L4.81836 14.559L4.52447 14.3455H4.88774L5 14Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.5L12.1123 9.84549H12.4755L12.1816 10.059L12.2939 10.4045L12 10.191L11.7061 10.4045L11.8184 10.059L11.5245 9.84549H11.8877L12 9.5Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M13 11L13.1123 11.3455H13.4755L13.1816 11.559L13.2939 11.9045L13 11.691L12.7061 11.9045L12.8184 11.559L12.5245 11.3455H12.8877L13 11Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9.5L10.1123 9.84549H10.4755L10.1816 10.059L10.2939 10.4045L10 10.191L9.70611 10.4045L9.81836 10.059L9.52447 9.84549H9.88774L10 9.5Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M11 11L11.1123 11.3455H11.4755L11.1816 11.559L11.2939 11.9045L11 11.691L10.7061 11.9045L10.8184 11.559L10.5245 11.3455H10.8877L11 11Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.5L8.11226 9.84549H8.47553L8.18164 10.059L8.29389 10.4045L8 10.191L7.70611 10.4045L7.81836 10.059L7.52447 9.84549H7.88774L8 9.5Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11L9.11226 11.3455H9.47553L9.18164 11.559L9.29389 11.9045L9 11.691L8.70611 11.9045L8.81836 11.559L8.52447 11.3455H8.88774L9 11Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M6 9.5L6.11226 9.84549H6.47553L6.18164 10.059L6.29389 10.4045L6 10.191L5.70611 10.4045L5.81836 10.059L5.52447 9.84549H5.88774L6 9.5Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M7 11L7.11226 11.3455H7.47553L7.18164 11.559L7.29389 11.9045L7 11.691L6.70611 11.9045L6.81836 11.559L6.52447 11.3455H6.88774L7 11Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M5 11L5.11226 11.3455H5.47553L5.18164 11.559L5.29389 11.9045L5 11.691L4.70611 11.9045L4.81836 11.559L4.52447 11.3455H4.88774L5 11Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4444_49389",
    x: 0,
    y: 5,
    width: 28,
    height: 23,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.164706 0 0 0 0 0.168627 0 0 0 0 0.188235 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4444_49389"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4444_49389",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFlagsEurUsd);
export default __webpack_public_path__ + "static/media/ic_flags_eur_usd.c8a3fe59.svg";
export { ForwardRef as ReactComponent };